<div class="row">
    <div class="col-12">

        <div class="card">
            <div class="card-header">
                <div class="title">{{ 'PRODUCT.SETTING_FOR_UPLOADING_FILES' | translate }}</div>
                <div class="tools">
                    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss(false)">
                        <svg-icon  src="/assets/images/icons/close.svg" [stretch]="true"
                        [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
                    </button>
                </div>
            </div>
            <div class="card-body">

                <nav>
                    <div class="nav nav-tabs" id="nav-tab" role="tablist">
                      <a class="nav-link active" [ngClass]="{'active': switchTab === 'settings'}" id="nav-settings-tab" data-toggle="tab" href="#nav-settings" role="tab" aria-controls="nav-settings" aria-selected="true" (click)="switchTabs('settings')">{{ 'DIALOG.UPLOAD.UPLOAD_SETTING' | translate }}</a>
                      <a class="nav-link" [ngClass]="{'active': switchTab === 'history'}"  id="nav-history-tab"  data-toggle="tab" href="#nav-history" role="tab" aria-controls="nav-history" aria-selected="true" (click)="switchTabs('history')">{{ 'DIALOG.UPLOAD.UPLOAD_HISTORY' | translate }}</a>
                      <!-- <a class="nav-link" [ngClass]="{'active': switchTab === 'porgress'}"  id="nav-porgress-tab" data-toggle="tab" href="#nav-porgress" role="tab" aria-controls="nav-porgress" aria-selected="true" (click)="switchTabs('porgress')">{{ 'DIALOG.UPLOAD.UPLOAD_PROGRESS' | translate }}</a> -->
                    </div>
                </nav>

                    <div class="tab-content" id="nav-tabContent">

                        <!-- SETTINGS -->
                        <div class="tab-pane fade active" id="nav-settings"  [ngClass]="{'show active': switchTab === 'settings'}" role="tabpanel" aria-labelledby="nav-settings-tab">

                            <app-products-download-with-settings [objectData]="orgAndProductIds"></app-products-download-with-settings>

                        </div>

                        <!-- HISTORY -->
                        <div class="tab-pane fade" id="nav-history" [ngClass]="{'show active': switchTab === 'history'}" role="tabpanel" aria-labelledby="nav-history-tab">

                            <app-products-download-history [objectData]="orgAndProductIds"></app-products-download-history>

                        </div>

                        <!-- PROGRESS -->
                        <div class="tab-pane fade" id="nav-porgress" [ngClass]="{'show active': switchTab === 'porgress'}" role="tabpanel" aria-labelledby="nav-porgress-tab">

        
                        </div>
                            
                </div>

            </div>
            <div class="modal-footer btn-box">
                <button type="button" class="btn btn-light btn-sm btn-back"   (click)="activeModal.dismiss(false)">{{ 'CLOSE' | translate}}</button>
            </div>
        </div>

    </div>
</div>